export default interface ProcessBarItem {
  icon: string;
  activeIcon: string;
  label: string;
  link: string;
  tag: string;
};

export enum ProcessBarTag {
  AWB_LIST = 'awbList',
  CART = 'cart',
  PAYMENT = 'payment',
  ORDER = 'order'
};
